export class CartoForm {

  public motsCles: string = '';
  public secteurActivite: string = '';
  public theme: string = '';
  public categorie: string = '';
  public canalVente: string = '';

  constructor() { }

  reset() {
    this.motsCles = '';
    this.secteurActivite = '';
    this.theme = '';
    this.categorie = '';
    this.canalVente = '';
  }
}
